<template>
    <div class="tw-subject" :class="{ 'tw-subject-fullscreen': fullscreen }">
        <div style="display: flex;">
            <!-- 标题插槽 -->
            <slot name="title">
                <span class="tw-subject-title">{{title}}</span>
            </slot>

            <div class="tw-subject-options" style="margin-left:auto;">
                <slot name="options">
                </slot>
                <div style="display: inline; margin-left: 10px;">
                    <div class="tw-subject-options-item" v-tooltip.bottom="'选项'" v-if="option_setting" @click="onClickSettings">
                        <i class="pi pi-cog"></i>
                    </div>
                    <div class="tw-subject-options-item" v-tooltip.bottom="'查询'" v-if="option_query" @click="onClickQuery">
                        <i class="pi pi-search"></i>
                    </div>
                    <div class="tw-subject-options-item" v-tooltip.bottom="'全屏'" v-if="option_fullscreen" @click="onFullscreen">
                        <i class="pi pi-window-maximize"></i>
                    </div>
                    <div class="tw-subject-options-item" v-tooltip.bottom="'更多'" v-if="option_more" @click="onClickMore">
                        <!-- 点击更多时可能会跳转，不设置 append-to-body 时跳转后 tooltip 在新页面上，造成布局上的问题 -->
                        <i class="pi pi-ellipsis-h"></i>
                    </div>
                </div>
            </div>
        </div>

        <!-- 面板内容（默认插槽） -->
        <div>
            <slot></slot>
        </div>
    </div>
</template>

<script>
import { ref } from 'vue'

export default {
    name: 'tw-subject',
    props: {
        title: {
            type: String,
            // required: true,
            default: '栏目标题'
        },
        option_query: {
            type: Boolean,
            default: true
        },
        option_setting: {
            type: Boolean,
            default: true
        },
        option_fullscreen: {
            type: Boolean,
            default: true
        },
        option_more: {
            type: Boolean,
            default: true
        }
    },
    emits: {
        "click-more": null,
        "click-query": null,
        "click-settings": null
    },
    setup(props, context) {
        const fullscreen = ref(false)

        const onFullscreen = function() {
            fullscreen.value = !fullscreen.value
            setTimeout(() => {
                try {
                    // 全屏时需要触发 resize 事件，用于部份组件需手动监听事件重绘界面
                    var ev = document.createEvent('Event');
                    ev.initEvent('resize', true, true);
                    window.dispatchEvent(ev);
                } catch (e) {
                    console.error('手动触发 resize 事件出错：', e)
                }
            }, 0);
        }

        const onClickMore = function() {
            context.emit('click-more' )
        }

        const onClickQuery = function() {
            context.emit('click-query')
        }

        const onClickSettings = function() {
            context.emit('click-settings')
        }

        return {
            fullscreen,
            onFullscreen,
            onClickMore, onClickQuery, onClickSettings
        }
    }
}
</script>

<style>

</style>